
function redirectToExternalSite() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Extract the token and wrap it in the desired structure
      var structuredData = {
        token: cart.token
      };

      // Stringify the structured data and encode it
      var cartParam = encodeURIComponent(JSON.stringify(structuredData));
      console.log
      // Redirect to the external site with the structured data as a query parameter
      window.location.href = 'https://Ozerty Canada.blink-checkout.com/?cart='+ cartParam +'&shop_name=Ozerty Canada;'
    });
}

document.addEventListener('DOMContentLoaded', function() {
  var checkoutButtons = document.querySelectorAll('button[name="checkout"]');

  checkoutButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      // prevent the default action
      event.preventDefault();

      redirectToExternalSite();
    });
  });
});
